<template>
  <IziGrid class="enter-pin">
    <IziCol col="8">
      <IziInput label="Ennter PIN code to join" v-model:value="Pin" />
    </IziCol>
    <IziCol col="4" class="col-join">
      <IziButton
        :disabled="!Pin"
        class="btn-join-login"
        label="JOIN"
        buttonType="primary"
        theme="outlined"
        card="true"
        @click="joinGame"
      />
    </IziCol>
  </IziGrid>
</template>

<script lang="ts">
import Base from "../base/Base.vue";
export default class EnterPin extends Base {
  Pin = "";

  joinGame() {
    const { displayName, email } = this.currentUser as any;
    const link = `${this.baseUrl}/player/?pin=${this.Pin}&name=${displayName}&email=${email.replace(
      "@",
      "%40"
    )}&avatar=${this.currentUser.photoURL}`;
    if (this.Pin) {
      window.open(link);
    }
  }
}
</script>

<style lang="scss">
.enter-pin {
  width: 310px;
  .col-join {
    align-self: center;
    text-align: center;
  }
}
</style>
